var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-button-container',[_c('info-link-action',{attrs:{"link":_vm.link}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }